import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import {FingerBasicPage} from "../finger-basic/finger-basic";
import {FingerFlashCardPage} from "../finger-flash-card/finger-flash-card";
import {FingerLittleFriendMinusPage} from "../finger-little-friend-minus/finger-little-friend-minus";
import {FingerLittleFriendPlusPage} from "../finger-little-friend-plus/finger-little-friend-plus";
import {FingerBigFriendPlusPage} from "../finger-big-friend-plus/finger-big-friend-plus";
import {FingerBigFriendMinusPage} from "../finger-big-friend-minus/finger-big-friend-minus";
import {FingerPlusMinusPage} from "../finger-plus-minus/finger-plus-minus";
import {FingerLittleFriendMixPage} from "../finger-little-friend-mix/finger-little-friend-mix";
import {FingerBigFriendMixPage} from "../finger-big-friend-mix/finger-big-friend-mix";
import {FingerExamPage} from "../finger-exam/finger-exam";

/**
 * Generated class for the FingerBoardPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-finger-board',
    templateUrl: 'finger-board.html',
})
export class FingerBoardPage {
    fingerFlashCardPage = FingerFlashCardPage;
    fingerBasicPage = FingerBasicPage;
    fingerLittleFriendPlusPage = FingerLittleFriendPlusPage;
    fingerLittleFriendMinusPage = FingerLittleFriendMinusPage;
    fingerLittleFriendMixPage = FingerLittleFriendMixPage;
    fingerBigFriendPlusPage = FingerBigFriendPlusPage;
    fingerBigFriendMinusPage = FingerBigFriendMinusPage;
    fingerBigFriendMixPage = FingerBigFriendMixPage;
    fingerPlusMinusPage = FingerPlusMinusPage;
    fingerExamPage = FingerExamPage;

    constructor(public navCtrl: NavController, public navParams: NavParams) {
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad FingerBoardPage');
    }

}



// WEBPACK FOOTER //
// ./src/pages/finger-board/finger-board.ts